import { EmptyState } from "@design-system/EmptyState/EmptyState";

interface Props {
    isError: boolean;
    hasActiveFilters: boolean;
    onRetry: () => void;
    onClearFilters: () => void;
    onCreateTemplate: () => void;
}

export const OrganizationTaskTemplatesEmptyState = ({
    isError,
    hasActiveFilters,
    onRetry,
    onClearFilters,
    onCreateTemplate,
}: Props) => {
    if (isError) {
        return (
            <EmptyState
                header="Failed to load task templates"
                ctaText="Retry"
                action={onRetry}
            />
        );
    }
    if (hasActiveFilters) {
        return (
            <EmptyState
                header="No task templates found"
                body="No task templates match your search or filters."
                ctaText="Clear filters"
                action={onClearFilters}
            />
        );
    }
    return (
        <EmptyState
            header="No task templates yet"
            body="Create a task template to reuse the same task across your service templates."
            ctaText="New template"
            action={onCreateTemplate}
        />
    );
};
